export type AuthMode = 'MINI_APP' | 'WEB'

let sdkLoad: Promise<void> | undefined

export function isTelegramMiniApp(): boolean {
  return telegramInitData().length > 0
}

export function authMode(): AuthMode {
  return isTelegramMiniApp() ? 'MINI_APP' : 'WEB'
}

export function initializeTelegram() {
  if (!isTelegramMiniApp()) return
  const current = telegramWebApp()
  if (current) configure(current)
  else void loadTelegramSdk().then(() => {
    const loaded = telegramWebApp()
    if (loaded) configure(loaded)
  })
}

export function haptic(type: 'tap' | 'success' | 'error' | 'select' = 'tap') {
  const telegram = telegramWebApp()
  if (!isTelegramMiniApp() || !telegram?.HapticFeedback) {
    if (type === 'error' && 'vibrate' in navigator) navigator.vibrate?.(40)
    return
  }
  if (type === 'success' || type === 'error') {
    telegram.HapticFeedback.notificationOccurred(type)
  } else if (type === 'select') {
    telegram.HapticFeedback.selectionChanged()
  } else {
    telegram.HapticFeedback.impactOccurred('medium')
  }
}

export function authHeaders(): Record<string, string> {
  const initData = telegramInitData()
  if (initData) return { Authorization: `tma ${initData}` }
  if (import.meta.env.DEV && import.meta.env.VITE_DEV_TELEGRAM_USER_ID) {
    return { 'X-Dev-Telegram-User-Id': import.meta.env.VITE_DEV_TELEGRAM_USER_ID }
  }
  return {}
}

function telegramWebApp() {
  return typeof window === 'undefined' ? undefined : window.Telegram?.WebApp
}

function telegramInitData() {
  const fromSdk = telegramWebApp()?.initData?.trim()
  if (fromSdk) return fromSdk
  if (typeof window === 'undefined') return ''
  for (const value of [window.location.hash.replace(/^#/, ''), window.location.search.replace(/^\?/, '')]) {
    const initData = new URLSearchParams(value).get('tgWebAppData')?.trim()
    if (initData) return initData
  }
  return ''
}

function configure(telegram: TelegramWebApp) {
  telegram.ready()
  telegram.expand()
  telegram.enableClosingConfirmation()
  telegram.setHeaderColor('#0c0d12')
  telegram.setBackgroundColor('#0c0d12')
}

function loadTelegramSdk() {
  if (sdkLoad) return sdkLoad
  if (typeof document === 'undefined' || telegramWebApp() || !isTelegramMiniApp()) return Promise.resolve()
  sdkLoad = new Promise<void>((resolve) => {
    const script = document.createElement('script')
    script.src = 'https://telegram.org/js/telegram-web-app.js'
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => resolve()
    document.head.appendChild(script)
  })
  return sdkLoad
}

